import { useState, useRef, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import { Container } from "react-bootstrap";
import StudySummary from '../StudySummary/StudySummary';
import Carousel from 'react-bootstrap/Carousel';
import Modal from 'react-bootstrap/Modal';
import CarouselNavHelper from '../../helpers/CarouselNavHelper.js';

import PartTwo_One from './StudyTwoIntroComponents/PartTwo_One.jsx'; 
import PartTwo_Two from './StudyTwoIntroComponents/PartTwo_Two.jsx';
import PartTwo_Three from './StudyTwoIntroComponents/PartTwo_Three.jsx';
import PartTwo_Four from './StudyTwoIntroComponents/PartTwo_Four.jsx';
import PartTwo_Five from './StudyTwoIntroComponents/PartTwo_Five.jsx';
import PartTwo_Six from './StudyTwoIntroComponents/PartTwo_Six.jsx';
import PartTwo_Seven from './StudyTwoIntroComponents/PartTwo_Seven.jsx'
import PartTwo_Eight from './StudyTwoIntroComponents/PartTwo_Eight.jsx'
import PartTwo_Nine from './StudyTwoIntroComponents/PartTwo_Nine.jsx'
import PartTwo_Reflection from './StudyTwoIntroComponents/PartTwo_Reflection.jsx'
import PartTwo_Final from './StudyTwoIntroComponents/PartTwo_Final.jsx'

import StudyProgressConfig from '../../helpers/StudyProgressBarConfig.js';
import { StudyProgressContext } from '../../Context';

const StudyTwoIntroSessionOnward = () => {
    const [carouselState, setCarouselState] = useState({
        index: 0,
        direction: null,
        carouselItemCount: 11
    });

    const navigate = useNavigate();
    const carouselNavHelper = new CarouselNavHelper();
    const [isLastPage, setIsLastPage] = useState(false);
    const [isFirstPage, setIsFirstPage] = useState(true);
    const [sessionThreeSubmitted, setSessionThreeSubmitted] = useState(false);
    const [sessionFourSubmitted, setSessionFourSubmitted] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [ModalMessage, setModalMessage] = useState('');
    const [ModalTitle, setModalTitle] = useState('');

    const contentRefs = useRef([]);
    const [isNextEnabled, setIsNextEnabled] = useState(false);

    // Create a resize observer to detect when elements are resized
    const resizeObserver = useRef(null);

    const { studyProgress, setStudyProgress } = useContext(StudyProgressContext);
    const progressByPageConfig = new StudyProgressConfig().getStudyTwoSessionOnwardProgressByPageConfig();

    const handleStartStudyTwoSessionOnward = () => {
        Cookies.set('current_study_two_session', 2, { expires: 7 });
        toggleCarousel('next');
        navigate("/explore");
    };

    const handleScroll = (index) => {
        const content = contentRefs.current[index];
        const isEnable = carouselNavHelper.allowNextButton(index, content, true, true, sessionThreeSubmitted, sessionFourSubmitted);
        setIsNextEnabled(isEnable);

        // console.log(`isScrollable ${isScrollable}, isBottomReached ${isBottomReached}, isNextEnabled ${!isScrollable || isBottomReached}`);
    };

    useEffect(() => {
        const content = contentRefs.current[carouselState.index];
    
        // Disconnect any previous observer
        if (resizeObserver.current) {
            resizeObserver.current.disconnect();
        }
    
        // Create a new ResizeObserver to monitor size changes of the content
        resizeObserver.current = new ResizeObserver(() => {
            const content = contentRefs.current[carouselState.index];
            const isEnable = carouselNavHelper.allowNextButton(carouselState.index, content, true, true, sessionThreeSubmitted, sessionFourSubmitted);
            setIsNextEnabled(isEnable);
        });
    
        // Observe the current content
        if (content) {
            resizeObserver.current.observe(content);
        }
    
        return () => {
            if (resizeObserver.current) {
                resizeObserver.current.disconnect();
            }
        };
    }, [carouselState.index, sessionThreeSubmitted, sessionFourSubmitted]);

    const handleShowModal = (isShow, title, message) => {
        setShowModal(isShow);

        if (title) setModalTitle(title);
        if (message) setModalMessage(message);
    };


    const toggleCarousel = (direction) => {
        let index = carouselState.index;
        const [min, max] = [0, carouselState.carouselItemCount - 1];
        setIsLastPage(false);
        setIsFirstPage(false);

        if (direction === 'next') {
            index++;
        } else if (direction === 'prev') {
            index--;
        }

        setStudyProgress(progressByPageConfig[index]);

        if (index >= max) {
            index = max;
            setIsLastPage(true);
        }

        if (index <= min) {
            index = min;
            setIsFirstPage(true);
        }

        setCarouselState({
            ...carouselState,
            index,
            direction
        });

        // Reset next button enabled state
        setIsNextEnabled(false);
    };

    return (
        <div className="content">
            <div className="tabcontent">
                <div className="container message-card carousel-container">

                    <Carousel activeIndex={carouselState.index} direction={carouselState.direction} interval={null} controls={false}>
                        <Carousel.Item>
                            <Container className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }}
                                ref={(el) => (contentRefs.current[0] = el)} 
                                onScroll={() => handleScroll(1)}
                            >
                                <PartTwo_One />
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }}
                                ref={(el) => (contentRefs.current[1] = el)} 
                                onScroll={() => handleScroll(2)}
                            >
                                <PartTwo_Two/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }}
                                ref={(el) => (contentRefs.current[2] = el)} 
                                onScroll={() => handleScroll(3)}
                            >
                                <PartTwo_Three/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container 
                                className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }} 
                                onScroll={() => handleScroll(4)}
                                ref={(el) => (contentRefs.current[3] = el)}
                            >
                                <PartTwo_Four/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container 
                                className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }} 
                                onScroll={() => handleScroll(4)}
                                ref={(el) => (contentRefs.current[4] = el)}
                            >
                                <PartTwo_Five/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container 
                                className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }} 
                                onScroll={() => handleScroll(4)}
                                ref={(el) => (contentRefs.current[5] = el)}
                            >
                                <PartTwo_Six/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container 
                                className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }} 
                                onScroll={() => handleScroll(4)}
                                ref={(el) => (contentRefs.current[6] = el)}
                            >
                                <PartTwo_Seven/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container 
                                className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }} 
                                onScroll={() => handleScroll(4)}
                                ref={(el) => (contentRefs.current[7] = el)}
                            >
                                <PartTwo_Eight/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container 
                                className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }} 
                                onScroll={() => handleScroll(4)}
                                ref={(el) => (contentRefs.current[8] = el)}
                            >
                                <PartTwo_Nine/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container 
                                className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }} 
                                onScroll={() => handleScroll(4)}
                                ref={(el) => (contentRefs.current[9] = el)}
                            >
                                <PartTwo_Reflection/>
                            </Container>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Container 
                                className="study-item" style={{ maxHeight: '80vh', overflowY: 'auto' }} 
                                onScroll={() => handleScroll(4)}
                                ref={(el) => (contentRefs.current[10] = el)}
                            >
                                <PartTwo_Final/>
                            </Container>
                        </Carousel.Item>
                    </Carousel>
                    <div className="carousel-button-container">
                        {isFirstPage ? null : (
                            <motion.button
                                type="button"
                                className="button carousel-button"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                                onClick={() => toggleCarousel('prev')}
                            >
                                <i className='bx bx-arrow-back'/>
                                {/* Previous */}
                            </motion.button>
                        )}
                        {isLastPage ? (
                            <motion.button
                                type="button"
                                className={`button carousel-button button-green ${isNextEnabled ? '' : 'button-disabled'}`}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                                onClick={() => handleStartStudyTwoSessionOnward()}
                                disabled={!isNextEnabled}
                            >
                                Start!
                            </motion.button>
                        ) : (
                            <motion.button
                                type="button"
                                className={`button carousel-button ${isNextEnabled ? '' : 'button-disabled'}`}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                                onClick={() => toggleCarousel('next')}
                                disabled={!isNextEnabled}
                            >
                                <i className='bx bx-arrow-back bx-rotate-180' />
                                {/* Next */}
                            </motion.button>
                        )}
                    </div>

                    <Modal show={showModal} onHide={() => handleShowModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>{ModalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{ModalMessage}</Modal.Body>
                        <Modal.Footer>
                            <motion.button
                                type="button"
                                className="button carousel-button"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.8 }}
                                onClick={() => handleShowModal(false)}
                            >
                                Got it!
                            </motion.button>
                        </Modal.Footer>
                    </Modal>

                </div>
            </div>
        </div>
    );
};

export default StudyTwoIntroSessionOnward;
